var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getBoxSize } from "../../utils";
import RenderImage from "./RenderImage";
import RenderString from "./RenderString";
import React, { useEffect, useMemo, } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import RenderMonth from "./RenderMonth";
import { ACTIONS, getDataByPartRef, getFirstRenderPartByResource, getPartRefById, getResource, } from "../../Providers/TemplateInstanceProvider";
import CropImage from "./CropImage";
import { getRotatedBoundingRect } from "./stringutils";
import { useTranslation } from "react-i18next";
import { useDrop } from "react-dnd";
import ImageAllowedValidator from "@/react/components/Template/ImageAllowedValidator";
import { usePortal } from "@/react/Providers/PortalProvider";
const useStyles = makeStyles({
    template: {
        backgroundColor: "white",
        position: "absolute",
        boxSizing: "border-box",
    },
    templateTrimBox: {
        overflow: "hidden",
        position: "absolute",
    },
});
const DrawTemplate = (props) => {
    const { templateInstance, containerSize, partRefId, year, zoomResource, handleUserImageClick, handleUserStringClick, handleTextInputFocus, handleTextInputBlur, handleTextInputChange, activeTextInputRef, handleCropUpdate, handleCropComplete, dispatch, outerPosition, userImageUrlCreator, mode, onDropItemOnImageResource, } = props;
    const classes = useStyles();
    const currentYear = year || templateInstance.year;
    console.log("Draw template", templateInstance);
    const partRef = useMemo(() => {
        return getPartRefById(partRefId || templateInstance.currentPartRefId || "", templateInstance.template);
    }, [templateInstance]);
    const templateData = useMemo(() => {
        return getDataByPartRef(partRef, templateInstance);
    }, [partRef, templateInstance]);
    const dimensions = templateInstance.template.dimensions;
    // We can fit template dimensions or zoomResource:
    let scaleData = useMemo(() => {
        var _a;
        let visibleArea = dimensions;
        console.log("Template and instance", templateInstance, templateData);
        if (templateInstance.template.trimBox) {
            visibleArea = templateInstance.template.trimBox;
        }
        let sizeInfo = getBoxSize("fit-in", visibleArea, {
            width: containerSize.width,
            height: containerSize.height,
        });
        let scaleRatio = (templateScaleRatio = sizeInfo.width / visibleArea.width);
        let zp = { x: 0, y: 0 };
        let transformScale = 1;
        if (isZoomedTemplateProps(props) && zoomResource) {
            resourceRenderElement = getFirstRenderPartByResource(zoomResource, templateInstance.template);
            if (resourceRenderElement) {
                let resourceDimensions = {
                    width: resourceRenderElement.size.width,
                    height: resourceRenderElement.size.height,
                };
                const rotation = (_a = resourceRenderElement.transformations) === null || _a === void 0 ? void 0 : _a.find((t) => t.type == "ROTATE");
                let position = resourceRenderElement.position;
                if (rotation) {
                    const boundingRect = getRotatedBoundingRect(resourceRenderElement.position, resourceRenderElement.size, rotation.rotate, { x: rotation.originX, y: rotation.originY });
                    resourceDimensions = {
                        width: boundingRect.width,
                        height: boundingRect.height,
                    };
                    position = {
                        x: boundingRect.x,
                        y: boundingRect.y,
                    };
                }
                let info = getBoxSize("fit-in", resourceDimensions, outerPosition);
                transformScale =
                    info.height / (resourceDimensions.height * scaleRatio);
                zp = {
                    x: -(position.x * scaleRatio * transformScale) -
                        (outerPosition.x - info.x),
                    y: -(position.y * scaleRatio * transformScale) -
                        (outerPosition.y - info.y),
                };
            }
        }
        return [scaleRatio, templateScaleRatio, zp, transformScale];
    }, [containerSize, zoomResource]);
    let [scaleRatio, templateScaleRatio, zp, transformScale] = scaleData;
    useEffect(() => {
        if (dispatch) {
            dispatch({
                type: ACTIONS.SET_SCALE_RATIO,
                scaleRatio,
            });
        }
    }, [scaleRatio]);
    // Why would this ever happend?
    if (!templateData) {
        throw new Error("Template data not found");
    }
    const transform = `translate3D(${zp.x}px, ${zp.y}px, 0)  scale(${transformScale}) `;
    console.log("Transform the stuff", transform);
    const styles = useMemo(() => {
        return {
            width: dimensions.width * scaleRatio + "px",
            height: dimensions.height * scaleRatio + "px",
            transformOrigin: "0 0 0",
            transform,
        };
    }, [zp, dimensions]);
    let resourceRenderElement = null;
    let trimBoxStyles = {
        width: dimensions.width * scaleRatio + "px",
        height: dimensions.height * scaleRatio + "px",
    };
    if (templateInstance.template.trimBox) {
        const trimBox = templateInstance.template.trimBox;
        trimBoxStyles = {
            // FIXME: Top and left probably does not work for displaycategory.php, need  a fix for it.
            left: -(trimBox.x * scaleRatio) + "px",
            top: -(trimBox.y * scaleRatio) + "px",
            width: trimBox.width * scaleRatio + "px",
            height: trimBox.height * scaleRatio + "px",
        };
    }
    return (React.createElement("div", { style: trimBoxStyles, className: `${classes.templateTrimBox} template-inner-container` },
        React.createElement("div", { style: styles, className: `${classes.template} ` },
            React.createElement(RenderParts, { templateData: templateData, scaleRatio: scaleRatio, templateInstance: templateInstance, handleTextInputFocus: handleTextInputFocus, zoomResource: zoomResource, handleTextInputBlur: handleTextInputBlur, handleTextInputChange: handleTextInputChange, handleUserStringClick: handleUserStringClick, handleUserImageClick: handleUserImageClick, activeTextInputRef: activeTextInputRef, year: currentYear, mode: mode, userImageUrlCreator: userImageUrlCreator }),
            React.createElement(Overlays, { templateData: templateData, templateInstance: templateInstance, handleUserImageClick: handleUserImageClick, handleUserStringClick: handleUserStringClick, scaleRatio: scaleRatio, onDropItemOnImageResource: onDropItemOnImageResource }),
            handleCropUpdate &&
                zoomResource &&
                "type" in zoomResource &&
                (zoomResource === null || zoomResource === void 0 ? void 0 : zoomResource.type) == "IMAGE" &&
                !zoomResource.disableZoom && (React.createElement(CropImage, { resource: zoomResource, handleCropUpdate: handleCropUpdate, handleCropComplete: handleCropComplete, scaleRatio: scaleRatio, template: templateInstance.template, renderPart: null })))));
};
const RenderParts = (props) => {
    let userResourceCount = 0;
    return (React.createElement(React.Fragment, null, props.templateData.renderParts.map((renderPart) => {
        const key = props.templateData.partRef.id + "#" + renderPart.resourceId;
        const { zoomResource, mode } = props, rest = __rest(props, ["zoomResource", "mode"]);
        const partZoomResource = zoomResource && zoomResource.id == renderPart.resourceId
            ? zoomResource
            : undefined;
        const zoomResourceId = zoomResource && zoomResource.fullId;
        // Heavy operation, only do this if we need:
        if (mode == "select-user-image" || mode == "select-user-text") {
            const resource = getResource(props.templateData.partRef, renderPart.resourceId, props.templateInstance);
            if ((resource === null || resource === void 0 ? void 0 : resource.userSupplied) && !(resource === null || resource === void 0 ? void 0 : resource.disableEdit)) {
                if (mode == "select-user-image" && resource.type == "IMAGE") {
                    userResourceCount++;
                }
                if (mode == "select-user-text" && resource.type == "STRING") {
                    userResourceCount++;
                }
            }
        }
        return (React.createElement(RenderPart, Object.assign({ key: key, renderPart: renderPart, zoomResource: partZoomResource, zoomResourceId: zoomResourceId, mode: mode, resourceNumber: userResourceCount }, rest)));
    })));
};
const RenderPart = React.memo(({ templateData, templateInstance, scaleRatio, zoomResource, handleUserImageClick, handleUserStringClick, handleTextInputFocus, handleTextInputChange, handleTextInputBlur, activeTextInputRef, zoomResourceId, year, renderPart, mode, resourceNumber, userImageUrlCreator, }) => {
    const resource = useMemo(() => {
        return (zoomResource === null || zoomResource === void 0 ? void 0 : zoomResource.id) == renderPart.resourceId
            ? zoomResource
            : getResource(templateData.partRef, renderPart.resourceId, templateInstance);
    }, [
        templateData.partRef,
        renderPart.resourceId,
        templateInstance,
        zoomResource,
    ]);
    switch (renderPart.type) {
        case "IMAGE":
            return (React.createElement(RenderImage, { renderPart: renderPart, resource: resource, handleUserImageClick: handleUserImageClick, zoomResource: zoomResource, scaleRatio: scaleRatio, mode: mode, zoomResourceId: zoomResourceId, resourceNumber: resourceNumber, templateInstance: templateInstance, userImageUrlCreator: userImageUrlCreator }));
        case "STRING":
            return (React.createElement(RenderString, { renderPart: renderPart, resource: resource, monthStrings: templateData.partRef.months, handleTextInputFocus: handleTextInputFocus, handleTextInputBlur: handleTextInputBlur, handleTextInputChange: handleTextInputChange, handleUserStringClick: handleUserStringClick, zoomResource: zoomResource, scaleRatio: scaleRatio, year: year, mode: mode, activeTextInputRef: (resource === null || resource === void 0 ? void 0 : resource.fullId) == zoomResourceId && activeTextInputRef
                    ? activeTextInputRef
                    : undefined, resourceNumber: resourceNumber }));
        case "MONTH":
            return (React.createElement(RenderMonth, { renderPart: renderPart, resource: resource, monthStrings: templateData.partRef.months, scaleRatio: scaleRatio, year: year }));
    }
    return null;
});
const Overlays = React.memo(({ templateData, templateInstance, handleUserImageClick, handleUserStringClick, scaleRatio, onDropItemOnImageResource, }) => {
    const filteredRenderParts = templateData.renderParts.filter((renderPart) => {
        const resource = getResource(templateData.partRef, renderPart.resourceId, templateInstance);
        console.log("Overlay resource", renderPart.resourceId, resource);
        if (!resource) {
            return false;
        }
        if (resource.type == "IMAGE" && !handleUserImageClick) {
            return false;
        }
        if (resource.type == "STRING" && !handleUserStringClick) {
            return false;
        }
        if (resource.disableEdit) {
            return false;
        }
        return resource.userSupplied;
    });
    let currentImageIndex = -1;
    let currentStringIndex = -1;
    let currentResoureIndex = -1;
    const userResourceOverslays = [];
    for (const renderPart of filteredRenderParts) {
        const key = templateData.partRef.id + "#" + renderPart.resourceId;
        const resource = getResource(templateData.partRef, renderPart.resourceId, templateInstance);
        if (resource.type == "IMAGE") {
            currentImageIndex++;
            currentResoureIndex = currentImageIndex;
        }
        else {
            currentStringIndex++;
            currentResoureIndex = currentStringIndex;
        }
        let clickHandler;
        if (resource.type === "IMAGE" && handleUserImageClick) {
            const imageRes = resource;
            clickHandler = (e) => handleUserImageClick(e, imageRes);
        }
        else if (resource.type === "STRING" && handleUserStringClick) {
            const stringRes = resource;
            clickHandler = (e) => handleUserStringClick(e, stringRes);
        }
        userResourceOverslays.push(React.createElement(UserResourceOverlay, { key: key, resourceIndex: currentResoureIndex, template: templateInstance.template, resource: resource, renderPart: renderPart, onClick: clickHandler, scaleRatio: scaleRatio, isSelectedResource: templateInstance.currentResourceId === resource.fullId, onDropItemOnImageResource: onDropItemOnImageResource }));
    }
    return React.createElement(React.Fragment, null, userResourceOverslays);
});
const UserResourceOverlay = (props) => {
    if (props.onDropItemOnImageResource) {
        return React.createElement(UserResourceOverlayWithDnD, Object.assign({}, props));
    }
    return (React.createElement(UserResourceOverlayBase, Object.assign({}, props, { isOver: undefined, canDrop: undefined, drop: undefined })));
};
const UserResourceOverlayWithDnD = (props) => {
    const portal = usePortal();
    const imageValidator = useMemo(() => {
        const imageAllowedValidator = new ImageAllowedValidator(props.template, portal.webshop.template);
        return imageAllowedValidator;
    }, [props.template, portal]);
    const [{ isOver, canDrop }, drop] = useDrop({
        accept: ["IMAGE", "BACKGROUND"],
        canDrop: (item, _monitor) => {
            if (!props.onDropItemOnImageResource) {
                return false;
            }
            if (item.type === "IMAGE" && props.resource.type === "IMAGE") {
                try {
                    imageValidator.imageAllowedInResource(item.image, props.resource);
                    return true;
                }
                catch (e) {
                    return false;
                }
            }
            else {
                return props.resource.type === "IMAGE" && item.type === "BACKGROUND";
            }
        },
        drop: (item, monitor) => {
            if (props.resource.type !== "IMAGE") {
                return monitor;
            }
            if (item.type === "IMAGE") {
                props.onDropItemOnImageResource &&
                    props.onDropItemOnImageResource(props.resource, item.image);
            }
            else if (item.type === "BACKGROUND") {
                props.onDropItemOnImageResource &&
                    props.onDropItemOnImageResource(props.resource, item.background);
            }
            return monitor;
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    });
    return (React.createElement(UserResourceOverlayBase, Object.assign({}, props, { isOver: isOver, canDrop: canDrop, drop: drop })));
};
const UserResourceOverlayBase = ({ resource, renderPart, resourceIndex, onClick, scaleRatio, isSelectedResource, isOver, canDrop, drop, }) => {
    var _a;
    console.log("Is over and can drop", isOver, canDrop);
    const [t] = useTranslation();
    let rotate = 0;
    let rotateOriginX = 0;
    let rotateOriginY = 0;
    const scaledRenderPart = useMemo(() => {
        return {
            width: renderPart.size.width * scaleRatio,
            height: renderPart.size.height * scaleRatio,
            x: renderPart.position.x * scaleRatio,
            y: renderPart.position.y * scaleRatio,
        };
    }, [renderPart, scaleRatio]);
    if (renderPart.transformations) {
        for (const transformation of renderPart.transformations) {
            if (transformation.type == "ROTATE") {
                rotate = transformation.rotate;
                rotateOriginY = transformation.originY * scaleRatio;
                rotateOriginX = transformation.originX * scaleRatio;
            }
        }
    }
    const styles = {
        position: "absolute",
        boxSizing: "border-box",
        width: scaledRenderPart.width + "px",
        height: scaledRenderPart.height + "px",
        top: scaledRenderPart.y + "px",
        left: scaledRenderPart.x + "px",
        backgroundColor: "transparent",
        border: "none",
        transformOrigin: `${rotateOriginX}px ${rotateOriginY}px`,
    };
    if (rotate) {
        styles.transform = `rotate(-${rotate}deg)`;
    }
    return (React.createElement("button", { ref: drop, className: `${isSelectedResource ? "Template-SelectedResourceOverlay" : ""}`, style: styles, "aria-label": (_a = t("type" in resource && resource.type === "IMAGE"
            ? "Edit image %d"
            : "Edit text %d", {
            postProcess: "sprintf",
            sprintf: [resourceIndex + 1],
        })) !== null && _a !== void 0 ? _a : "", onClick: (e) => onClick && onClick(e, resource) }, canDrop ? React.createElement(DropImageTarget, { isOver: !!isOver }) : null));
};
const DropImageTarget = ({ isOver }) => {
    return (React.createElement("div", { style: {
            width: "100%",
            height: "100%",
            outline: isOver ? "2 px solid red" : "",
        } }, "Drop here!"));
};
export default DrawTemplate;
function isZoomedTemplateProps(props) {
    return props.zoomResource !== undefined;
}
